import { http } from "../base";
import { uploadToOSS } from "@/api/aics/KbDocument.js";

export function uploadImage(formData) {
    return http.post(
        `/api/images/upload`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    )
}

// 上传图片到OSS
export async function uploadImageToOSS(file, tenantId) {
    console.log("uploadImageToOSS",file, tenantId);
    try {
        console.log('开始上传图片到OSS:', {
            fileName: file.name,
            tenantId,
            folderName: 'image-library' // 使用image-library文件夹
        })

        // 直接调用现有的OSS上传方法，修改文件夹参数
        const result = await uploadToOSS(file, tenantId || 0, 'image-library')
        console.log('OSS上传结果:', result)
        
        return result
    } catch (error) {
        console.error('OSS上传失败:', error)
        return {
            code: 500,
            message: 'OSS上传失败: ' + error.message,
            data: { success: false }
        }
    }
}

// 保存图片信息到应用端
export function saveImageInfo(data) {
    console.log("saveImageInfo", data)
    return http.post(
        `/aics/image_library/save_info`,    
        data
    )
}

export function getImages(params) {
    console.log("getImages", params)
    return http.get(
        `/aics/image_library/images`,
        { params }
    )
}

export function getCategories(tenantId) {
    console.log("getCategories", tenantId)
    return http.get(
        `/aics/image_categories/list?tenant_id=${tenantId}`
    )    
}

export function getCategoryDetail(id) {
    return http.get(
     `/aics/image_categories/${id}`
    )
}

export function addCategory(data) {
    console.log(data)
    return http.post(
        `/aics/image_categories/save`,
        data
    )    
}

export function updateCategory(data) {
    console.log("updateCategory", data)
    return http.post(
        `/aics/image_categories/save`,
        data
    )    
}

export function deleteCategory(id) {
    return http.delete(
   `/aics/image_categories/${id}`,
    )        
}

export function importDefaultCategory(tenant_id) {
    return http.post(
         `/aics/image_categories/import_default_category?tenant_id=${tenant_id}`
    )      
}

export function updateImage(data) {
    console.log(data);
    return http.put(
         `/aics/image_library/update_info`,
        data
    )
}

export function deleteImage(id) {
    return http.delete(
        `/aics/image_library/${id}`
    )
}

export function getTempImageUrl(imagePath) {
    console.log("getTempImageUrl", imagePath)
    return http.get(
        `/api/images/temp-url`,
        { params: { imagePath } }
    )
}